import request from '@/utils/request'

export function getOneProduct(id, params) {
  return request({
    url: `/api/products/${id}`,
    method: 'get'
  })
}

export function putProduct(id, data) {
  return request({
    url: `/api/products/${id}`,
    method: 'put',
    data
  })
}

export function postProduct(data) {
  return request({
    url: `/api/products`,
    method: 'post',
    data
  })
}

export function getProducts(params) {
  params = {...params, 'multysearch[status.statusId]': '1,2'}
  return request({
    url: '/api/products',
    method: 'get',
    params
  })
}

export function deleteProduct(id) {
  return request({
    url: `/api/products/${id}`,
    method: 'delete'
  })
}

export function getProductsCategories(params) {
  params = {...params, 'multysearch[status.statusId]': '1,2'}
  return request({
    url: '/api/product_categories',
    method: 'get',
    params
  })
}

export function deleteCategory(id) {
  return request({
    url: `/api/product_categories/${id}`,
    method: 'delete'
  })
}

export const getProductTransactions = (params) => request({
  url: 'api/product_transactions',
  method: 'get',
  params
})



// WEBPACK FOOTER //
// ./src/modules/products/api.js